import React, { useEffect, useRef, useState } from "react";
import { message, Button, Form, Input, Row, Col, Modal, Select } from "antd";
import { addCity, addState } from "./StateCityApi";

const AddStateCity = ({
  isOpen,
  setIsOpen,
  from,
  Fill,
  apiCall,
  currentPage,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [isLoading, setIsLoading] = useState(false);
  console.log(Fill);
  const createState = (changedValues) => {
    setIsLoading(true);
    let payload = {};
    if (from === "addState") {
      payload = {
        name: changedValues.name,
      };
      addState(payload)
        .then((response) => {
          if (response.data.status) {
            message.success({ content: response.data.message });
            apiCall(currentPage);
            setIsOpen(false);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      payload = {
        stateId: Fill.id,
        name: changedValues.name,
      };
      addCity(payload)
        .then((response) => {
          if (response.data.status) {
            message.success({ content: response.data.message });
            apiCall();
            setIsLoading(false);
            setIsOpen(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        createState(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      footer={null}
      visible={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      title={from === "addState" ? "Add State" : "Add City"}
    >
      <Form
        className="bg-rgbaprimary1 p-4 mt-4"
        layout="vertical"
        onFinishFailed={(err) => console.log(err)}
        onFinish={createState}
        form={form}
        ref={formRef}
      >
        <Row className="grid grid-cols-1">
          <Col>
            <Form.Item
              name="name"
              label={from === "addState" ? "Enter state" : "Enter City"}
              rules={[
                {
                  required: true,
                  message: "Please enter name",
                },
                {
                  message: "Please enter a valid  name",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row className="flex justify-between gap-4">
          <Form.Item className="mt-4">
            <Button
              className="bg-white  text-rgbaprimary9  hover:!bg-rgbaprimary8 hover:!text-white hover:!border-none"
              htmlType="reset"
            >
              Cancel
            </Button>
          </Form.Item>
          <Form.Item className="mt-4">
            <Button
              className="bg-rgbaprimary9  text-white  hover:!bg-rgbaprimary8 hover:!text-white hover:!border-none"
              htmlType="submit"
              disabled={isLoading}
              loading={isLoading}
            >
              {from === "addState" ? "Create state" : "Create City"}
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddStateCity;
